export type Documento = {
    IdDocsprime: number
    IdDocumento: number
    CodContaCorrente: number
    link: string
    tipoDocumento: string
}

export type Arquivo = {
    tipoArquivo: string
    conteudoBase64: string
}

export const Paginas: Map<string, string[]> = new Map()
export const Documentos: Map<string, Documento[]> = new Map()

import api from '../../plugins/api'
//import { pdf2jpeg } from '../../plugins/pdf';


export const getDocumento = async ({ codigo_condominio, IdDocsprime }: { codigo_condominio: number, IdDocsprime: number }): Promise<string[]> => {
    const key = `${codigo_condominio}.${IdDocsprime}`
    if (Paginas.has(key)) {
        return Paginas.get(key) as string[]
    }
    let { data: arquivos } = await api.get<Arquivo[]>(
        `condominios/${codigo_condominio}/livro-digital/${IdDocsprime}/arquivos`
    )

    const pdf2jpeg = await import('../../plugins/pdf').then(e => e.pdf2jpeg);

    let imagens = await Promise.all(arquivos.map(arquivo => {
        return pdf2jpeg(arquivo.conteudoBase64)
    }))

    let paginas = imagens.reduce((acc, imagens) => [...acc, ...imagens], [])

    Paginas.set(key, paginas)
    return paginas;
}


export const getDocumentos = async ({ codigo_condominio, codigo_livro_digital, id_docsprime }: { codigo_condominio: number, codigo_livro_digital: number, id_docsprime: number }): Promise<Documento[]> => {
    const key = `${codigo_condominio}.${codigo_livro_digital}.${id_docsprime}`

    if (Documentos.has(key)) {
        return Documentos.get(key) as Documento[]
    }

    let { data: documentos } = await api.get<Documento[]>(
        `condominios/${codigo_condominio}/livro-digital/${codigo_livro_digital}/${id_docsprime}/documentos`
    );

    Documentos.set(key, documentos)
    return documentos
}